export default __webpack_public_path__ + "cbca2a84fbd95571307cc5aa0b11595d.svg";